// The dashboard's one "nothing to show" block. A panel with no rows still has
// to look designed — an icon, what the panel is for, and what will fill it —
// rather than leaving a sentence floating in a white rectangle.
//
// Styling lives with the other primitives in styles/dashboard.css (.dshBlank*)
// so every empty panel on the page is the same object.
const BlankState = ({ icon: Icon, title, text, className = '', children }) => (
  <div className={`dshBlank ${className}`}>
    {Icon && (
      <span className="dshBlankIcon">
        <Icon size={19} strokeWidth={2.1} />
      </span>
    )}
    <p className="dshBlankTitle">{title}</p>
    {text && <p className="dshBlankText">{text}</p>}
    {children}
  </div>
);

export default BlankState;
